"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appConfigsReducer = void 0;
var getAppConfigByName_1 = require("./actions/getAppConfigByName");
var initialState = {
    loading: false,
};
var appConfigsReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case getAppConfigByName_1.GET_APPLICATION_CONFIGS.REQUEST:
            return __assign(__assign({}, state), (_a = {}, _a[action.keyName] = undefined, _a.loading = true, _a));
        case getAppConfigByName_1.GET_APPLICATION_CONFIGS.SUCCESS:
            return __assign(__assign({}, state), (_b = {}, _b[action.keyName] = action.response, _b.loading = false, _b));
        case getAppConfigByName_1.GET_APPLICATION_CONFIGS.FAILURE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
exports.appConfigsReducer = appConfigsReducer;
//# sourceMappingURL=appConfigs.reducer.js.map